/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-12 12:31:51
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-07-19 16:58:17
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/TopConfigs/ContentSetting/index.tsx
 */
/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:07:36
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-07 14:54:39
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/TopConfigs/index.tsx
 */
import { Uploader } from '@/src/components';
import { Input } from '@/src/components/Antd';
//import { ImageDisplaySetting } from '@/src/components/Upload';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
//import { cloneDeep } from 'lodash';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { contentSettingValidation, errKey } from '../../validation';

import { useSingleImageEffect } from '@/src/components/Upload';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { EPreviewSize, WebSiteSubType } from '@/src/types/common/SalesChannel';
import { get } from 'lodash';
import FocusPoint from 'src/components/ImageFocusPointEdit';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getContentSetting,
  getSubmitStamp,
  onCollapseOpen,
  onContentSettingChange,
  onErrorChange,
  resetContentSetting,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/slice';
import { store } from 'src/store';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';

function ContentSetting(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const dispatch = useDispatch();
  const { data, specificError, currentStyle, currentSize } = props;
  const isResponsivePage = currentStyle === WebSiteSubType.ResponsivePage;
  const hideUploaderFunc =
    isResponsivePage &&
    (currentSize === EPreviewSize.TABLET ||
      currentSize === EPreviewSize.MOBILE);
  const textErr = specificError[errKey.contentTextErr];
  const imgErr = specificError[errKey.contentImageErr];

  const { text, image } = data;

  // const coordinate =
  //   image?.imageSetting?.left &&
  //   image?.imageSetting?.top &&
  //   image?.imageSetting?.bottom &&
  //   image?.imageSetting?.right
  //     ? {
  //         leftTop: image?.imageSetting?.left,
  //         rightTop: image?.imageSetting?.top,
  //         leftBottom: image?.imageSetting?.bottom,
  //         rightBottom: image?.imageSetting?.right,
  //       }
  //     : undefined;
  //const coordinateFocal = image?.imageSetting?.focus;
  //const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = useState(image ? [image] : []);
  useSingleImageEffect(image, fileList, setFileList);

  const handleImageChange = (list: Array<any>) => {
    const length = list.length;
    const image = length ? list[length - 1] : null;
    setFileList(list);
    dispatch(onContentSettingChange({ image }));
  };

  const handleContentChange = (type: string, value: string) => {
    dispatch(onContentSettingChange({ [type]: value }));
  };

  const handleChangeImage = (img) => {
    // console.log('value111', value);
    // console.log('focalValue111', focalValue);
    // const img = cloneDeep(image);
    // img['imageSetting'] = {
    //   focus: focalValue,
    //   left: value.leftTop,
    //   top: value.rightTop,
    //   bottom: value.leftBottom,
    //   right: value.rightBottom,
    // };
    dispatch(onContentSettingChange(img));
    //setVisible(false);
  };

  return (
    <Section>
      <ItemWrapper
        error={(imgErr || []).length > 0}
        errorText={(imgErr || []).join(' ')}
        title='Image*'
        bottomTitle='Allowed file types: jpeg, gif, png, mov, mp4'>
        <Uploader
          // hideEdit={hideUploaderFunc}
          // hideReplace={hideUploaderFunc}
          // hideRemove={hideUploaderFunc}
          multiple={false}
          height={180}
          fileList={fileList}
          onChange={handleImageChange}
        />
        <FocusPoint
          className={styles.imageSetting}
          image={get(fileList, 0)}
          onChange={handleChangeImage}
          disable={!isResponsivePage}
        />
        {/* {hideUploaderFunc && (
          <>
            <div
              className={styles.imageSetting}
              onClick={() => setVisible(!!image?.url)}>
              {'Image Display Setting'}
            </div>
            <ImageDisplaySetting
              src={image?.url}
              value={coordinate}
              visible={visible}
              focalValue={coordinateFocal}
              onCancel={() => setVisible(false)}
              onOk={handleChangeImage}
            />
          </>
        )} */}
      </ItemWrapper>

      {!hideUploaderFunc && (
        <ItemWrapper title={getI18n('general.text')}>
          <Input
            error={(textErr || []).length > 0}
            help={(textErr || []).join(' ')}
            size={'large'}
            className={styles.input}
            placeholder={'please input text'}
            fullyControlledFilter={(v) => v}
            value={text}
            onChange={handleContentChange.bind(this, 'text')}
          />
        </ItemWrapper>
      )}
    </Section>
  );
}

export default ErrorProcessingHOC(ContentSetting, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.contentSetting,
  getContent: getContentSetting,
  title: 'Content Setting',
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return contentSettingValidation(x, !isPrimary);
  },
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(resetContentSetting());
        },
        key: 'Reset',
        body: 'Reset',
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
